import { useMemo } from "react";

import theme from "theme";
import { colors } from "theme/palette";

import Box from "components/Box";
import Stack from "components/Stack";
import Tag from "components/Tag";
import Text from "components/Text";

import PrintableMemoFieldTitle from "pages/Deal/PrintableMemo/components/PrintableMemoFieldTitle";
import PrintableFilesTable from "pages/PrintableChecklist/components/PrintableFilesTable";

import { IPackageDetailsField } from "entities/Checklist/sdk";
import { IFilefieldCustomValue } from "entities/Field/components/Filefield/FilesTable";

interface IPrintableMemoFilefield {
  field: IPackageDetailsField;
  isNASection: boolean;
}

const PrintableMemoFilefield = ({
  field,
  isNASection,
}: IPrintableMemoFilefield) => {
  const customValues = useMemo(
    () => (field.values as Array<IFilefieldCustomValue>) || [],
    [field]
  );

  const isNAField = useMemo(
    () => field.n_a_status || isNASection,
    [field, isNASection]
  );

  return (
    <Box>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        spacing={2}
        sx={{
          paddingBottom: theme.spacing(1),
          borderBottom: `1px solid ${colors.blue40}`,
        }}
      >
        <PrintableMemoFieldTitle field={field} disabled={isNAField} />

        {isNAField && (
          <Box sx={{ "@media screen": { display: "none" } }}>
            <Text sx={{ opacity: 0.5 }} data-testid="field-value-na">
              N/A
            </Text>
          </Box>
        )}
      </Stack>

      {customValues.length > 0 && (
        <Box
          sx={{
            marginTop: 1,
            paddingLeft: 6,
          }}
        >
          <Tag
            label="file uploads"
            variant="gray20"
            sx={{ display: "inline-block", marginBottom: 1 }}
            dataTestid="uploaded-fields-tag-label"
          />
          <PrintableFilesTable customFieldValues={customValues} />
        </Box>
      )}
    </Box>
  );
};

export default PrintableMemoFilefield;
